if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}

// polyfills for HTML5 player on LG
require('@cbc-player/polyfill')

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign')

require('raf/polyfill')

require('core-js/es/weak-map')
require('core-js/es/map')
require('core-js/es/set')
require('core-js/es/array')
require('core-js/es/array/iterator')
require('core-js/es/symbol')
require('core-js/es/string/includes')
require('core-js/es/string/starts-with')
require('core-js/es/string/ends-with')
// require('core-js/es/object/create') // included in @cbc-player/polyfill
require('core-js/es/object/freeze')
// require('core-js/es/object/entries') // included in @cbc-player/polyfill
require('core-js/es/object/values')

require('@cbc/hbbtv-keyboardevent-key-polyfill').polyfill()

// fetch (webOS 3.x)
require('whatwg-fetch')
